import { PageContextUtils, TrackingUtils } from "../../utils";
import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { LocalizationMessages } from "../../localization/messages";
import PropTypes from "prop-types";
import {
  StateSwitcherSelectors,
  UserContextSelectors
} from "../../redux/selectors";
import { useSelector } from "react-redux";
import { SVGIcon2 } from "../../components/common/SVGIconV2";
import { loadRewardResources, RewardsResource } from "./loader";
import { BrandUtils } from "../../utils/brandUtils";
import { useLocationHandler } from "../../hooks/useLocationHandler";

const useRewardsResources = () => {
  const { name } = PageContextUtils.getClientProviderData();
  const [resources, setResources] = useState(null);
  const brandId = useSelector(UserContextSelectors.brandId);
  useEffect(() => {
    const getResources = async () => {
      const resources = await (RewardsResource?.promise ??
        loadRewardResources(brandId, name));
      setResources(resources);
    };

    getResources();
  }, [name, brandId]);

  return resources;
};

const handleTracking = () => {
  TrackingUtils.sendAnalytics({
    dataCategory: "User Area",
    dataAction: "click",
    dataLabel: "Rewards",
    dataValue: ""
  });
};

const Rewards = ({ onClick }) => {
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const resources = useRewardsResources();
  const { openLocationConfirmationPopup } = useLocationHandler();
  const isClickEnabled = resources?.alwaysEnabled || isAuthenticated;
  const className = isClickEnabled ? "aCrewards enabled" : "aCrewards";
  const selectedState = useSelector(StateSwitcherSelectors.selectedState);

  const handleRewardsClick = () => {
    handleTracking();

    if (!isClickEnabled) {
      return;
    }
    handleOnClick();
    handleResourcesAction();
  };

  const handleOnClick = () => {
    onClick?.();
  };

  const handleResourcesAction = () => {
    if (typeof resources.action === "function") {
      if (
        !isAuthenticated &&
        BrandUtils.isSiSportsBook() &&
        (!selectedState || selectedState.length <= 1)
      ) {
        openLocationConfirmationPopup();
      } else {
        resources.action(isAuthenticated);
      }
    }
  };

  return (
    resources && (
      <a
        href={isClickEnabled ? resources.link : undefined}
        className={className}
        onClick={handleRewardsClick}
        data-testid="uc-my-account-area-rewards"
      >
        <div className="aCrewardsIndicator">
          <div className="aCrewardsIndicatorBadge" />
        </div>
        <SVGIcon2 iconName="rewards" />
        <div className="aCrewardsTitle">
          <FormattedMessage {...LocalizationMessages.rewards} />
        </div>
      </a>
    )
  );
};

Rewards.propTypes = {
  onClick: PropTypes.func
};

export default React.memo(Rewards);
